(function() {
  
  let arrowLeft = '<svg xmlns="http://www.w3.org/2000/svg" width="26.578" height="51.156" viewBox="0 0 26.578 51.156"><path id="Left" d="M51.637,65.77,27.473,41.606,51.637,17.442" transform="translate(-26.473 -16.028)" fill="none" stroke="#030504" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>';
  let arrowRight = '<svg xmlns="http://www.w3.org/2000/svg" width="26.578" height="51.156" viewBox="0 0 26.578 51.156"><path id="Right" d="M51.637,65.77,27.473,41.606,51.637,17.442" transform="translate(53.052 67.184) rotate(180)" fill="none" stroke="#030504" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>';
  var gridSlider = function() {

    $('div[data-section-type="collection-template"][data-grid-type="slider"]').each(function(){
      var slideItem = $(this).find('.grid-slider'); 
      slideItem.not('.slick-initialized').slick({
        slidesToShow: 5,
        slidesToScroll: 2,
        prevArrow: '<button type="button" class="slick-prev">'+arrowLeft+'</button>',
        nextArrow: '<button type="button" class="slick-next">'+arrowRight+'</button>',
        cssEase: 'ease-in-out',
        speed: 500,
        responsive: [
         {
            breakpoint: 1300,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2, 
            }
          },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2, 
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1, 
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1, 
            }
          }
        ]
      });
    }); 

  };

  var thumbnailsSlider = function(){
    
      let arrowLeft = '<svg xmlns="http://www.w3.org/2000/svg" width="26.578" height="51.156" viewBox="0 0 26.578 51.156"><path id="Left" d="M51.637,65.77,27.473,41.606,51.637,17.442" transform="translate(-26.473 -16.028)" fill="none" stroke="#030504" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>';
  let arrowRight = '<svg xmlns="http://www.w3.org/2000/svg" width="26.578" height="51.156" viewBox="0 0 26.578 51.156"><path id="Right" d="M51.637,65.77,27.473,41.606,51.637,17.442" transform="translate(53.052 67.184) rotate(180)" fill="none" stroke="#030504" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>';
  
    
      $('.thumbnailsSlider').slick({ 
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical:true,
        infinite: true,
        centerMode: true,
        prevArrow: '<button type="button" class="slick-prev">'+arrowLeft+'</button>',
    nextArrow: '<button type="button" class="slick-next">'+arrowRight+'</button>',
        responsive: [
          {
            breakpoint: 769,
            settings: "unslick"
          } 
        ]
      });  
  }

 gridSlider();
 thumbnailsSlider();

  $(document).on('shopify:section:load', function(event) { 
   gridSlider();
   thumbnailsSlider();
  });
}());


jQuery(window).scroll(function(){
  var sticky = jQuery('.header-container'),
      scroll = jQuery(window).scrollTop();

  if (scroll >= 30) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});

$(document).ready(function(e) 
{
  
    $(document).on('click','a[href="#cartItemRemove"]',function(e){
    e.preventDefault();
	$(this).parents('.ajaxcart__row').find('.ajaxcart__qty-num').val(0).trigger('change');
    });
  
	$("a.open-bio").click(function() 
	{
		$(this).nextAll('.bio-more').first().toggle();
		$(this).toggleClass('active');
		return false;
	});
  
  let arrowLeft = '<svg xmlns="http://www.w3.org/2000/svg" width="26.578" height="51.156" viewBox="0 0 26.578 51.156"><path id="Left" d="M51.637,65.77,27.473,41.606,51.637,17.442" transform="translate(-26.473 -16.028)" fill="none" stroke="#030504" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>';
  let arrowRight = '<svg xmlns="http://www.w3.org/2000/svg" width="26.578" height="51.156" viewBox="0 0 26.578 51.156"><path id="Right" d="M51.637,65.77,27.473,41.606,51.637,17.442" transform="translate(53.052 67.184) rotate(180)" fill="none" stroke="#030504" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>';
  
    $('.carousel-product').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 2,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev">'+arrowLeft+'</button>',
    nextArrow: '<button type="button" class="slick-next">'+arrowRight+'</button>',
    //prevArrow: "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    //nextArrow: "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        responsive: [
         {
            breakpoint: 1300,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2, 
            }
          },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2, 
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1, 
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1, 
            }
          }
        ]
  });
  
});

$(document).ready(function() {	
  $('.et-tablink').click(function() {	
    var tab = $(this).data('tab');	
    $('.et-tabs-header .et-tablink').removeClass('active');	
    $('.et-tabs-content .et-tab-content').removeClass('active');	
    $(this).addClass('active');	
    $(".et-tabs-content #" + tab).addClass('active');	
  });
  $('.acc_list .acc_title').click(function() {
    var current_status = $(this).parent().find(".acc_desc").css('display');
    $('.acc_title').removeClass('active');
    $('.acc_list .acc_desc').slideUp();
    if(current_status == 'none') {
      $(this).addClass('active');
      $(this).parent().find(".acc_desc").slideDown();
    }
  });
  
    var mobileSearchIcon = setInterval(function() {
    if($('a[href="#mobiSearch"] form[action="/pages/search-results-page"]').length) {
      $('a[href="#mobiSearch"]').removeClass('disabled');
      clearInterval(mobileSearchIcon);
    }
  }, 100);
  
   var annoucment_slide = $('.announcement-bar').slick({
     infinite: true,
     slideToShow:1,
     autoplay: true,
     autoplaySpeed: 2000,
     arrows:false,
     vertical: true
  });
  
  
}); 
